/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DisputeEventPublicationResponse } from '../models';
// @ts-ignore
import type { DisputeEventRequest } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { WebhookEventsResponse } from '../models';
/**
 * WebhookEventsApi - axios parameter creator
 * @export
 */
export const WebhookEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve all supported webhook events with descriptions for Partner UI webhook event subscription
         * @summary Get supported webhook events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedWebhookEvents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/webhook-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Publish a `payment.dispute.created` / `payment.dispute.resolved` event to the partner\'s webhook subscriptions. Intended for service-to-service communication (payment-reporting → Platform Admin Service) and requires OAuth scope `service.webhook.event:publish`.  Exactly-once on the caller-supplied deterministic `eventId`: a duplicate request (e.g. a scheduler retry of an already-published event) returns 202 without re-publishing. A transient failure returns 5xx so the caller retries. 
         * @summary Publish a partner dispute webhook event (service-to-service)
         * @param {DisputeEventRequest} disputeEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDisputeEvent: async (disputeEventRequest: DisputeEventRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'disputeEventRequest' is not null or undefined
            assertParamExists('publishDisputeEvent', 'disputeEventRequest', disputeEventRequest)
            const localVarPath = `/api/v1/webhook-events/disputes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(disputeEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhookEventsApi - functional programming interface
 * @export
 */
export const WebhookEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhookEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve all supported webhook events with descriptions for Partner UI webhook event subscription
         * @summary Get supported webhook events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedWebhookEvents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedWebhookEvents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookEventsApi.getSupportedWebhookEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Publish a `payment.dispute.created` / `payment.dispute.resolved` event to the partner\'s webhook subscriptions. Intended for service-to-service communication (payment-reporting → Platform Admin Service) and requires OAuth scope `service.webhook.event:publish`.  Exactly-once on the caller-supplied deterministic `eventId`: a duplicate request (e.g. a scheduler retry of an already-published event) returns 202 without re-publishing. A transient failure returns 5xx so the caller retries. 
         * @summary Publish a partner dispute webhook event (service-to-service)
         * @param {DisputeEventRequest} disputeEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishDisputeEvent(disputeEventRequest: DisputeEventRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisputeEventPublicationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishDisputeEvent(disputeEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookEventsApi.publishDisputeEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebhookEventsApi - factory interface
 * @export
 */
export const WebhookEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhookEventsApiFp(configuration)
    return {
        /**
         * Retrieve all supported webhook events with descriptions for Partner UI webhook event subscription
         * @summary Get supported webhook events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedWebhookEvents(options?: RawAxiosRequestConfig): AxiosPromise<WebhookEventsResponse> {
            return localVarFp.getSupportedWebhookEvents(options).then((request) => request(axios, basePath));
        },
        /**
         * Publish a `payment.dispute.created` / `payment.dispute.resolved` event to the partner\'s webhook subscriptions. Intended for service-to-service communication (payment-reporting → Platform Admin Service) and requires OAuth scope `service.webhook.event:publish`.  Exactly-once on the caller-supplied deterministic `eventId`: a duplicate request (e.g. a scheduler retry of an already-published event) returns 202 without re-publishing. A transient failure returns 5xx so the caller retries. 
         * @summary Publish a partner dispute webhook event (service-to-service)
         * @param {DisputeEventRequest} disputeEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDisputeEvent(disputeEventRequest: DisputeEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<DisputeEventPublicationResponse> {
            return localVarFp.publishDisputeEvent(disputeEventRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebhookEventsApi - object-oriented interface
 * @export
 * @class WebhookEventsApi
 * @extends {BaseAPI}
 */
export class WebhookEventsApi extends BaseAPI {
    /**
     * Retrieve all supported webhook events with descriptions for Partner UI webhook event subscription
     * @summary Get supported webhook events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookEventsApi
     */
    public getSupportedWebhookEvents(options?: RawAxiosRequestConfig) {
        return WebhookEventsApiFp(this.configuration).getSupportedWebhookEvents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Publish a `payment.dispute.created` / `payment.dispute.resolved` event to the partner\'s webhook subscriptions. Intended for service-to-service communication (payment-reporting → Platform Admin Service) and requires OAuth scope `service.webhook.event:publish`.  Exactly-once on the caller-supplied deterministic `eventId`: a duplicate request (e.g. a scheduler retry of an already-published event) returns 202 without re-publishing. A transient failure returns 5xx so the caller retries. 
     * @summary Publish a partner dispute webhook event (service-to-service)
     * @param {DisputeEventRequest} disputeEventRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookEventsApi
     */
    public publishDisputeEvent(disputeEventRequest: DisputeEventRequest, options?: RawAxiosRequestConfig) {
        return WebhookEventsApiFp(this.configuration).publishDisputeEvent(disputeEventRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

